// removed by extract-text-webpack-plugin
module.exports = {"Spacer":"Spacer__1oDjN"};